(function($, undefined) {
	"use strict";
	
	$.fn.formData = function (ajax) {
		let data = $(this).serializeArray().reduce((prev, curr) => {
			const element = $(`[name=${curr.name}]`, this);

			try {
				prev[curr.name] = tinymce.get(element.attr('id')).getContent();
			} catch (ex) {
				prev[curr.name] = curr.value;
			}

			return prev;
		}, {});

		if (ajax) {
			data.ajax = true;
		}

		return data;
	}; 
	
})(jQuery);